import { useMediaQuery } from "@mantine/hooks";

export const useIsDesktop = () => {
  return useMediaQuery("(min-width: 62em)");
};
